export const SUPPLIER_DETAILS_SHOW = "SUPPLIERS_PORTAL_SUPPLIER_SHOW";
export const SUPPLIER_DETAILS_UPDATE = "SUPPLIERS_PORTAL_SUPPLIER_UPDATE";
